module.exports = __webpack_public_path__ + "nvalidation_icon.svg";